import React from 'react';

import { Route, Routes } from 'react-router-dom';

import NotFoundPage from 'components/errors/NotFoundPage/NotFoundPage';
import ErrorPage from 'components/errors/ErrorPage/ErrorPage';
import MainLayout from 'components/MainLayout/MainLayout';
import ApplicationsPage from 'components/applications/ApplicationsPage/ApplicationsPage';
import SignInPage from 'components/auth/SignInPage/SignInPage';
import RequestResetPasswordPage from 'components/auth/RequestReserPasswordPage/RequestResetPasswordPage';
import ResetPasswordPage from 'components/auth/ResetPasswordPage/ResetPasswordPage';
import PrivateRoute from 'routes/PrivateRoute';
import SignUpPage from 'components/auth/SignUpPage/SignUpPage';
import EnterConfirmationCode from 'components/auth/EnterConfirmationCodePage/EnterConfirmationCodePage';
import Application from 'components/applications/ApplicationPage/ApplicationPage';
import MyAccount from 'components/myProfile/MyProfile';
import CompanyProfile from 'components/intermediaryApplications/CompanyProfile/CompanyProfile';
import PrivacyPolicy from 'components/documents/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from 'components/documents/TermsOfUse/TermsOfUse';
import useScript from 'hooks/useScript';
import { useSentryContext } from 'hooks/useSentryContext';
import MdaPreviewPage from 'components/MainLayout/Mda/MdaPreviewPage/MdaPreviewPage';
import UsersManagement from 'components/users/UsersManagement/UsersManagement';
import CompanyNotifications from 'components/companyNotifications/CompanyNotifications';
import AccountStatus from 'components/accountStatus/AccountStatus';
import RoleManagement from 'components/roles/RoleManagement/RoleManagement';
import { PermissionName } from 'components/permissions/permissions.enum';
import EntryForm from 'components/prequalification/EntryForm/EntryForm';
import EntryFormResult from 'components/prequalification/EntryFormResult/EntryFormResult';
import RegistrationProcess from 'components/prequalification/RegistrationProcess/RegistrationProcess';
import ThankYouPage from 'components/prequalification/ThankYouPage/ThankYouPage';
import ExpiredSession from 'components/prequalification/ExpiredSession/ExpiredSession';
import { PrequalificationEntrySource } from 'components/prequalification/RegistrationProcess/registrationProcess.enums';

import { ApplicationRoute } from './routes.enums';

export const ApplicationRoutes = () => {
  useScript(`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&v=weekly`);
  useSentryContext();

  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={ApplicationRoute.Home} element={<PrivateRoute />}>
          <Route path={ApplicationRoute.MyProfile} element={<MyAccount />} />
          <Route path={ApplicationRoute.ConfirmEmail} element={<EnterConfirmationCode />} />
          <Route path={ApplicationRoute.AccountStatus} element={<AccountStatus />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.ConsumerApplication]} />}>
          <Route index element={<ApplicationsPage />} />
          <Route path={ApplicationRoute.Application} element={<Application />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.UserView]} />}>
          <Route path={ApplicationRoute.UsersManagement} element={<UsersManagement />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.CompanyVerificationUpdate]} />}>
          <Route
            path={ApplicationRoute.PortalRegistration}
            element={<RegistrationProcess entrySource={PrequalificationEntrySource.Portal} />}
          />
          <Route path={ApplicationRoute.MdaPreview} element={<MdaPreviewPage />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.CompanyInformationView]} />}>
          <Route path={ApplicationRoute.CompanyProfile} element={<CompanyProfile />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.CompanyNotificationsUpdate]} />}>
          <Route path={ApplicationRoute.CompanyNotifications} element={<CompanyNotifications />} />
        </Route>
        <Route element={<PrivateRoute requiredPermissions={[PermissionName.RoleUpdate]} />}>
          <Route path={ApplicationRoute.RoleManagement} element={<RoleManagement />} />
        </Route>
        <Route path={ApplicationRoute.Login} element={<SignInPage />} />
        <Route path={ApplicationRoute.SignUp} element={<SignUpPage />} />
        <Route path={ApplicationRoute.RequestResetPassword} element={<RequestResetPasswordPage />} />
        <Route path={ApplicationRoute.ResetPassword} element={<ResetPasswordPage />} />
        <Route path={ApplicationRoute.Other} element={<NotFoundPage />} />
        <Route path={ApplicationRoute.Error} element={<ErrorPage />} />
        <Route path={ApplicationRoute.PrivacyPolicy} element={<PrivacyPolicy />} />
        <Route path={ApplicationRoute.TermsOfUse} element={<TermsOfUse />} />
        <Route path={ApplicationRoute.Prequalification} element={<EntryForm />} />
        <Route path={ApplicationRoute.PrequalificationEntryFormResult} element={<EntryFormResult />} />
        <Route
          path={ApplicationRoute.PrequalificationRegistration}
          element={<RegistrationProcess entrySource={PrequalificationEntrySource.Registration} />}
        />
        <Route path={ApplicationRoute.PrequalificationThankYou} element={<ThankYouPage />} />
        <Route path={ApplicationRoute.PrequalificationExpiredSession} element={<ExpiredSession />} />
      </Route>
    </Routes>
  );
};
